<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">Açıklama {{data.descriptionId ? 'Güncelle' : 'Ekle'}}</h4>
    <button type="button" class="close" (click)="close(false)" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="descriptionForm">
        <!-- Başlık -->
        <div class="form-group">
            <label for="title">Başlık</label>
            <input type="text" id="title" class="form-control" formControlName="title" />
        </div>

        <!-- Tür -->
        <div class="form-group d-flex align-items-center justify-content-between">
            <!-- Tür -->
            <div class="w-75 pr-2">
                <label for="type">Tür</label>
                <ng-select [items]="types" bindLabel="label" bindValue="id" formControlName="type"
                    placeholder="Tür seçiniz">
                </ng-select>
            </div>

            <!-- Aktif mi -->
            <div class="w-25 pl-2 d-flex align-items-center" style="margin-top: 1.6rem">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" id="customCheck1"
                        [checked]="descriptionForm.get('isActive')?.value"
                        (change)="descriptionForm.get('isActive')?.setValue($event.target.checked)" />
                    <label class="custom-control-label" for="customCheck1">Aktif</label>
                </div>
            </div>
        </div>

        <!-- Açıklama -->
        <div class="form-group">
            <label for="description">Açıklama</label>
            <quill-editor formControlName="description">
                <div quill-editor-toolbar>
                    <span class="ql-formats">
                        <button class="ql-bold" [title]="'Bold'"></button>
                        <button class="ql-italic" [title]="'italic'"></button>
                        <button class="ql-underline" [title]="'underline'"></button>
                    </span>
                    <span class="ql-formats">
                        <select class="ql-size"></select>
                        <select class="ql-align" [title]="'Alignment'">
                            <option selected></option>
                            <option value="center"></option>
                            <option value="right"></option>
                            <option value="justify"></option>
                        </select>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-list" value="ordered" type="button"></button>
                    </span>
                    <span class="ql-formats">
                        <button class="ql-link" value="ordered" type="button"></button>
                    </span>
                </div>
            </quill-editor>
        </div>
    </form>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close(false)">İptal</button>
    <button type="button" class="btn btn-primary" [disabled]="descriptionForm.invalid" (click)="save()">Kaydet</button>
</div>